import React from "react";
import { X } from "lucide-react";

const ExitGameModal = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 font-quicksand">
      <div
        className="p-7 max-w-md mx-4 relative"
        style={{
          background: "white",
          borderRadius: "20px",
          border: "2px solid #f9a8d4",
          boxShadow: "0 8px 32px rgba(176,106,179,0.15)",
        }}
      >
        <button
          onClick={onCancel}
          className="absolute top-3 right-3 hover:scale-110 transition-transform"
          style={{ color: "#c4b5fd" }}
        >
          <X size={20} />
        </button>

        <div className="text-center mb-6">
          <h3 className="text-lg font-bold mb-4" style={{ color: "#b06ab3" }}>
            ¿Ya te vas, bb? 👀
          </h3>
          <p className="text-sm mb-3" style={{ color: "#6b7280" }}>
            Si te sales ahorita, pierdes tu progreso…
          </p>
          <p className="text-xs italic" style={{ color: "#9b7eaa" }}>
            ⭐ Pero tranqui, tu récord sí se guarda.
          </p>
          <span className="text-xs italic" style={{ color: "#9b7eaa" }}>
            (salvo si andas en incógnito, bb 👀)
          </span>
        </div>

        <div className="flex justify-center gap-3">
          <button
            onClick={onConfirm}
            className="px-5 py-2 bg-custom-blue text-white rounded-full active:scale-95 transition-transform"
            style={{
              boxShadow: "0 4px 12px rgba(125,211,252,0.4)",
              color: "#0c4a6e",
            }}
          >
            Sí, salir
          </button>
          <button
            onClick={onCancel}
            className="px-5 py-2 rounded-full active:scale-95 transition-transform"
            style={{
              background: "rgba(196,181,253,0.15)",
              border: "1.5px solid #c4b5fd",
              color: "#6d28d9",
            }}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExitGameModal;
